export const frontApiUrl = {

    LOGIN: "api/v1/admin/adminLogin",
    EMAIL_NOTIFICATION: "api/v1/admin/adminEmailNotification",
    VERIFY_OTP: "api/v1/admin/adminOtpVerify",
    RESET_PASSWORD: "api/v1/admin/adminChangePassword",


    // Dashboard
    USER_STATICS: "api/v1/adminDashboard/dashboard-statics",
    RECENT_USERS: "api/v1/adminDashboard/recent-users",

    // Users
    PARTIAL_USERS: "api/v1/adminDashboard/partial-users",
    USER_LIST: "api/v1/adminUserControler/userList",
    GET_INTERESTS: "api/v1/adminUserControler/getInterset",
    EDIT_USER: "api/v1/adminUserControler/editUser",
    FILE_UPLOAD: "api/v1/adminUserControler/fileUploads",
    GET_USER_DETAILS: "api/v1/adminUserControler/getParticularUser",
    DELETE_USER: "api/v1/adminUserControler/deleteUser",



    // Post
    POST_LIST: "api/v1/adminPostControler/postList",
    PARTICULAR_POST: "api/v1/adminPostControler/particularPost",
    DELETE_COMMENT: "api/v1/adminPostControler/deleteComment",
    
    EDIT_POST: "api/v1/adminPostControler/editPost",
    DELETE_POST: "api/v1/adminPostControler/deletePost",
    FLAGS_REPORTS: "api/v1/adminPostControler/FlagsReport",
    DELETE_FLAGS_REPORTS: "api/v1/adminPostControler/deleteFlagsReport",
    ALL_COMMENTS_REPLIES: "api/v1/adminPostControler/getCommentReplies",
    DELETE_COMMENT_REPLIES: "api/v1/adminPostControler/deleteCommentReply",
   



    // ads
    ADS_LIST: "api/v1/adminads/adsList",
    VIEW_ADS: "api/v1/adminads/particularAds",
    APPROVE_ADS: "api/v1/adminads/approveAds",
    REJECT_ADS: "api/v1/adminads/rejectAds",
    DELETE_ADS: "api/v1/adminads/deleteAds",


    // interset
    GET_INTERESTS_LIST: "api/v1/adminPostControler/getIntersetList",
    ADD_INTERESTS: "api/v1/adminUserControler/addInterset",
    EDIT_INTERESTS: "api/v1/adminUserControler/editInterset",
    DELETE_INTERESTS: "api/v1/adminUserControler/deleteInterset",


    // contact us

    CONTACT_US_LIST: "api/v1/adminPostControler/contactUs",
    DELETE_CONTACT_US: "api/v1/adminPostControler/deleteContactUs",


    // terms and conditions

    GET_TERMS_CONDITIONS: "api/v1/adminPostControler/getTermsCondition",
    EDIT_TERMS_CONDITIONS: "api/v1/adminPostControler/editTermsCondition",


    // profile settings
    UPDATE_PROFILE: "api/v1/admin/adminUpdateProfile",
    UPDATE_PASSWORD: "api/v1/admin/adminChangePasswordSettig",








    
    
    
    
    }